/// <amd-module name="Analytics/Shared/Utils/DateSKParser" />
/**
 * Utility class to parse DateSKs returned by Analytics to JavaScript Date objects.
 */
export class DateSKParser {
    /**
     * Parses date surrogate key as a date string.
     * Ex. "20160101" will be returned as "2016-01-01"
     * @param dateSK - The date surrogate key to parse
     * @returns a date string representing the value of the dateSK
     */
    public static parseDateSKAsDateString(dateSK: number | undefined): string {
        if (dateSK != null) {
            const dateSKString = dateSK.toString();
            const year = dateSKString.substr(0, 4);
            const month = dateSKString.substr(4, 2);
            const day = dateSKString.substr(6, 2);

            const accountDateString = `${year}-${month}-${day}`;
            return accountDateString;
        } else {
            return "";
        }
    }

    /**
     * Takes a date string and returns a DateSK.
     * @param date A string of the format "yyyy-MM-dd"
     * @returns The DateSK representation of the string.
     */
    public static dateStringToDateSK(date: string): number {
        return +date.split("-").join("");
    }

    // TODO: Remove after Utils_Date format
    public static convertDateToDateString(date: Date): string {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();

        const array = [year, month <= 9 ? "0" + month : month, day <= 9 ? "0" + day : day];
        return array.join("-");
    }

    /**
     * Parses date surrogate key as a date.
     * Ex. "20160101" will returne Date for 1st Jan 2016
     * @param dateSK - The date surrogate key to parse
     * @returns a date representing the value of the dateSK
     */
    public static parseDateSKAsDate(dateSK: number): Date {
        return new Date(this.parseDateSKAsDateString(dateSK));
    }
}
